import React, { useState, useRef, useEffect } from "react";
import {
  collection,
  query,
  orderBy,
  addDoc,
  serverTimestamp,
  CollectionReference,
  where,
  Query,
} from "firebase/firestore";
import Modal from "react-bootstrap/Modal";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { db } from "../utils/Config";
import Chat from "../component/Chat";
import { getCookie } from "../utils/Common";
import TopBar from "../component/TopBar";
import SideBar from "../component/SideBar";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getCompanyEmployeesService } from "../services/CheckListService";
import { Apinames } from "../utils/Apiname";
interface Props {
  // user: any;
}

export interface Message {
  text: string;
  uid: string;
  companyId: string;
  createdAt: any;
}
const ChatScreen: React.FC<Props> = ({}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [employeeList, setEmployeeList] = useState([]);
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const cookie: any = getCookie("data");
  const dummy = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  const messagesRef = collection(
    db,
    "messages"
  ) as CollectionReference<Message>;
  const q = query(
    messagesRef,
    where("companyId", "==", cookie?.companyId),
    orderBy("createdAt")
  );

  const [messages] = useCollectionData<Message>(q);
  const [formValue, setFormValue] = useState("");

  useEffect(() => {
    getEmployeeList();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const sendMessage = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      if (!formValue.trim()) return;

      await addDoc(messagesRef, {
        text: formValue.trim(),
        createdAt: serverTimestamp(),
        uid: cookie?.id || "unknown",
        companyId: cookie?.companyId,
      });

      setFormValue("");
      dummy.current?.scrollIntoView({ behavior: "smooth" });
    } catch (error) {
      console.error("Failed to send message:", error);
      setErrorMessage(t("common.message_send_failed"));
      setErrorModalVisible(true);
    }
  };

  const getEmployeeList = async () => {
    try {
      let endpoint = Apinames.companyEmployees;
      const response = await getCompanyEmployeesService(endpoint);
      if (response?.result) {
        setEmployeeList(response?.result);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
    }
  };

  console.log("messages", messages, cookie?.company);
  return (
    <>
      <Modal
        show={errorModalVisible}
        className="chatErrorMModal"
        centered
        onHide={() => setErrorModalVisible(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="error" style={{textAlign:"center"}}>  {errorMessage}</p>
        </Modal.Body>
      </Modal>
      <div className="__dashboard">
        <div className="__dashboard__wrapper">
          <SideBar />
          <div className="__dashboardRightSide">
            <TopBar />
            <div className="__dashboardContent">
              <div className="live__chat">
                <div className="chat__box">
                  <div className="custormer__support">
                    {t("aces.chat.title")}
                    <div className="aces-on-brand">{t("aces.chat.subtitle")}</div>
                  </div>
                  <div className="chat__wraper">
                    <main>
                      {isLoading ? (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ height: "100px", marginTop: "110px" }}
                        >
                          <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </div>
                      ) : messages && messages.length > 0 ? (
                        <>
                          {messages.map((msg, index) => (
                            <Chat
                              key={index}
                              message={msg}
                              currentUid={cookie?.id}
                              employeeList={employeeList}
                            />
                          ))}
                        </>
                      ) : (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{
                            height: "100px",
                            marginTop: "110px",
                            color: "#888",
                          }}
                        >
                          <p>{t("common.no_company_messages")}</p>
                        </div>
                      )}
                      <div ref={dummy}></div>
                    </main>

                    <form onSubmit={sendMessage} className="sendmessageInput">
                      <input
                        value={formValue}
                        onChange={(e) => setFormValue(e.target.value)}
                        placeholder={t("placeholders.enter_message")}
                      />
                      <button
                        type="submit"
                        disabled={!formValue}
                        className="sendBtn"
                      >
                        <i className="ri-send-plane-2-fill"></i>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatScreen;
